function sortingToString (sorting) {
  if (sorting) {
    const sortDirection = sorting.direction === 'asc' ? '' : '-';
    return `${sortDirection}${sorting.name}`;
  }
  return null;
}

export default sortingToString;
